class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");

    if (facetForm) {
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

      facetForm.addEventListener("submit", (event) => {
        event.preventDefault();
        this.onSubmitHandler(event);
      });

      facetForm.addEventListener("click", (event) => {
        const { target } = event;

        if (target.classList && target.classList.contains("brandlist-mobile")) {
          event.preventDefault();
          this.onSubmitHandler(event);
          return;
        }

        if (target.tagName === "A") {
          const href = target.getAttribute("href");
          if (href) window.location = href;
        }
      });
    }

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const productGridContainer = document.getElementById("ProductGridContainer");
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");

    if (productGridContainer && productGridContainer.querySelector(".collection")) {
      productGridContainer.querySelector(".collection").classList.add("loading");
    }

    if (countContainer) countContainer.classList.add("loading");
    if (countContainerDesktop) countContainerDesktop.classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const newGrid = parsedHTML.getElementById("ProductGridContainer");
    const currentGrid = document.getElementById("ProductGridContainer");

    if (newGrid && currentGrid) {
      currentGrid.innerHTML = newGrid.innerHTML;
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const parsedCount = parsedHTML.getElementById("ProductCount");
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");

    if (parsedCount && container) {
      container.innerHTML = parsedCount.innerHTML;
      container.classList.remove("loading");
    }

    if (typeof Ajaxinate !== "undefined") {
      new Ajaxinate({
        container: "#product-grid",
        pagination: ".infinite_next",
      });
    }

    if (parsedCount && containerDesktop) {
      containerDesktop.innerHTML = parsedCount.innerHTML;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    const matchesIndex = (element) => {
      const jsFilter = event && event.target ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const currentElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );

      if (currentElement) {
        currentElement.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target && event.target.closest(".js-filter")) {
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);

      if (!activeFacetsElement || !currentElement) return;

      currentElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      const newElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);

      if (!newElement || !currentElement) return;

      currentElement.innerHTML = newElement.innerHTML;
    });

    const mobileForm = document.getElementById("FacetFiltersFormMobile");

    if (
      mobileForm &&
      mobileForm.closest("menu-drawer") &&
      typeof mobileForm.closest("menu-drawer").bindEvents === "function"
    ) {
      mobileForm.closest("menu-drawer").bindEvents();
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      targetElementAccessibility.outerHTML = sourceElementAccessibility.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams ? "?".concat(searchParams) : ""}`
    );
  }

  static getSections() {
    const productGrid = document.getElementById("product-grid");

    if (!productGrid || !productGrid.dataset.id) {
      return [];
    }

    return [
      {
        section: productGrid.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event) event.preventDefault();

    const target = event && event.target ? event.target : null;
    const targetForm = target && target.closest ? target.closest("form") : null;

    if (!targetForm) return;

    const sortFilterForms = document.querySelectorAll("facet-filters-form form");

    if (target && target.className === "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(target.closest("form"));
      this.onSubmitForm(searchParams, event);
      return;
    }

    const forms = [];
    const isMobile = targetForm.id === "FacetFiltersFormMobile";

    const activeElement = document.activeElement;

    if (
      (target.classList && target.classList.contains("brandListInput")) ||
      (activeElement && activeElement.classList && activeElement.classList.contains("brandListInput"))
    ) {
      if (!isMobile) {
        const brandInput = document.querySelector(".brandListInput");
        const value =
          brandInput && brandInput.value.length > 0
            ? brandInput.value
            : activeElement && activeElement.value
              ? activeElement.value
              : "";

        if (!value.length) {
          const currentUrl = location.pathname + location.search;
          const url = currentUrl.replace(/\/brand-.*\?/, "?");
          location = url;
          return;
        }

        const datalist = document.querySelector("#brandDataList");

        if (!datalist) return;

        const selected = Array.from(datalist.options).find(
          (option) => option.value.toLowerCase() === value.toLowerCase()
        );

        if (!selected || event.inputType === "insertText") {
          return;
        }

        const url = selected.dataset.value;

        if (url) {
          location = url;
        }

        return;
      } else {
        const mobileBrandInput = document.querySelector(".brandlist-mobile");
        const datalist = document.querySelector("#brandDataList");

        if (!mobileBrandInput || !datalist) return;

        const value = mobileBrandInput.value;

        datalist.style.display = "none";

        const search = Array.from(datalist.options)
          .filter((option) =>
            option.value.toLowerCase().includes(value.toLowerCase())
          )
          .map((option) => option.value);

        const parent = mobileBrandInput.parentElement
          ? mobileBrandInput.parentElement.parentElement
            ? mobileBrandInput.parentElement.parentElement.parentElement
            : null
          : null;

        if (!parent) return;

        let output = parent.querySelector("#brandList-mobile-results");

        if (!output) {
          output = document.createElement("ul");
          output.setAttribute("id", "brandList-mobile-results");
          output.style.maxHeight = "350px";
          output.style.overflowY = "scroll";
          output.style.backgroundColor = "#F1F1F1";
          output.style.paddingBlock = "10px";
          output.style.listStyle = "none";
          parent.append(output);
        }

        output.innerHTML = "";

        search.forEach((brand) => {
          const listItem = document.createElement("li");
          listItem.innerHTML = brand;
          listItem.style.cursor = "pointer";

          listItem.onclick = () => {
            mobileBrandInput.value = brand;
            output.innerHTML = "";
            output.append(listItem);
          };

          output.append(listItem);
        });
      }
    }

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetSortDrawerForm"
        ) {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === "FacetFiltersFormMobile") {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join("&"), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf("?") === -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

if (!customElements.get("facet-filters-form")) {
  customElements.define("facet-filters-form", FacetFiltersForm);
}

FacetFiltersForm.setListeners();

const currentUrl = window.location.pathname + window.location.search;
const brandDataList = document.querySelector("#brandDataList");

if (brandDataList) {
  const selected = Array.from(brandDataList.options).find(
    (option) => option.dataset.value === currentUrl
  );

  if (selected) {
    const input = document.querySelector(".brandListInput");
    const mobinput = document.querySelector(".brandlist-mobile");

    if (input) input.value = selected.value;
    if (mobinput) mobinput.value = selected.value;
  }
}

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);

    if (maxInput.value === "") {
      minInput.setAttribute("max", maxInput.getAttribute("max"));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get("price-range")) {
  customElements.define("price-range", PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector("a");

    if (!facetLink) return;

    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));

    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");

    if (form) {
      form.onActiveFilterClick(event);
    }
  }
}

if (!customElements.get("facet-remove")) {
  customElements.define("facet-remove", FacetRemove);
}

const applyFiltersButton = document.getElementById("apply-filters");

if (applyFiltersButton) {
  applyFiltersButton.addEventListener(
    "click",
    function (event) {
      event.preventDefault();

      let mobileFilters = "";

      const storeInput = document.getElementById("storelist-mobile");
      const sizeInput = document.getElementById("sizelist-mobile");
      const colorInput = document.getElementById("colorlist-mobile");
      const brandInput = document.querySelector(".brandlist-mobile");
      const datalist = document.querySelector("#brandDataList");
      const mobileFilterInput = document.getElementById("mobileFilter");
      const sortByInput = document.getElementById("SortBy-mobile");

      if (storeInput && storeInput.value !== "") {
        mobileFilters += "+" + storeInput.value;
      }

      if (sizeInput && sizeInput.value !== "") {
        mobileFilters += "+" + sizeInput.value;
      }

      if (colorInput && colorInput.value !== "") {
        mobileFilters += "+" + colorInput.value;
      }

      if (brandInput && brandInput.value !== "") {
        if (!datalist) {
          alert("Brand list is missing.");
          return;
        }

        const selected = Array.from(datalist.options).find(
          (option) => option.value.toLowerCase() === brandInput.value.toLowerCase()
        );

        if (selected && selected.dataset.value) {
          const brandMatch = /(brand-.*)\?/.exec(selected.dataset.value);

          if (brandMatch && brandMatch[1]) {
            mobileFilters += "+" + brandMatch[1];
          } else {
            alert("Invalid Brand");
            return;
          }
        } else {
          alert("Invalid Brand");
          return;
        }
      }

      mobileFilters = mobileFilters.replace(/^\+/, "");

      const baseUrl = mobileFilterInput
        ? mobileFilterInput.value.split("?")[0].replace(/\/$/, "")
        : window.location.pathname.replace(/\/$/, "");

      const sortValue = sortByInput && sortByInput.value
        ? sortByInput.value
        : "created-descending";

      const finalUrl = mobileFilters
        ? `${baseUrl}/${mobileFilters}?sort_by=${sortValue}`
        : `${baseUrl}?sort_by=${sortValue}`;

      window.location.href = finalUrl;
    },
    false
  );
}

const resetFiltersButton = document.getElementById("reset-filters");

if (resetFiltersButton) {
  resetFiltersButton.addEventListener(
    "click",
    function (event) {
      event.preventDefault();

      const storeInput = document.getElementById("storelist-mobile");
      const sizeInput = document.getElementById("sizelist-mobile");
      const styleInput = document.getElementById("stylelist-mobile");
      const colorInput = document.getElementById("colorlist-mobile");
      const brandInputById = document.getElementById("brandlist-mobile");
      const brandInputByClass = document.querySelector(".brandlist-mobile");
      const mobileFilterInput = document.getElementById("mobileFilter");

      if (storeInput) storeInput.value = "";
      if (sizeInput) sizeInput.value = "";
      if (styleInput) styleInput.value = "";
      if (colorInput) colorInput.value = "";
      if (brandInputById) brandInputById.value = "";
      if (brandInputByClass) brandInputByClass.value = "";

      window.location.href = mobileFilterInput
        ? mobileFilterInput.value.split("?")[0]
        : window.location.pathname;
    },
    false
  );
}